import gql from "graphql-tag";

const GET_LIQUIDM_TRAFFIC_SETS = gql`
  query liquidMTrafficSets($params: JSON) {
    liquidMTrafficSets(params: $params)
  }
`;

export default GET_LIQUIDM_TRAFFIC_SETS;
